import Main from "./pages/Main";
import Login from "./pages/Login";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { connect } from "react-redux";
import { AppDispatch, RootState } from "./app/store";
import "./App.css";
import { useEffect, useState } from "react";
import Loader from "./components/widgets/Loader";
library.add(fab);

const App = (props: any) => {
	const { oidc_user } = props;
	const [pageContent, setPageContent] = useState<any>(
		<div className="h-screen flex overflow-hidden bg-primary text-primary">
			<Loader />
		</div>
	);

	useEffect(() => {
		setTimeout(() => {
			if (oidc_user) {
				setPageContent(<Main />);
			} else {
				setPageContent(<Login />);
			}
		}, 1500);
	}, [oidc_user]);

	return pageContent;
};

function mapStateToProps(state: RootState) {
	return {
		oidc_user: state.oidc.user,
	};
}

function mapDispatchToProps(dispatch: AppDispatch) {
	return {
		dispatch,
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
